import React from 'react';
import { pathwayTriageDocuments } from '../../utils/triagePathways';
import { openableLetterLeaflets } from '../../constants/letterLeaflets';

/**
 * The leaflets that went out with an outcome letter (TDI-387), under the
 * letter on the family and school views. Reads what the send recorded on the
 * referral, and lists only leaflets a reader can open: a leaflet with no link
 * is not offered, because there is nothing to open yet. Renders nothing when
 * there is nothing to show, so the letter views are unchanged for autism
 * letters and for letters sent before leaflets existed.
 */
export default function LetterLeaflets({ patient, pathwayKey }) {
  const leaflets = openableLetterLeaflets(pathwayTriageDocuments(patient, pathwayKey));
  if (leaflets.length === 0) return null;
  return (
    <section className="family-letter-leaflets" aria-label="Leaflets sent with this letter">
      <h3 className="harbour-heading-24 family-letter-leaflets__title">Leaflets sent with this letter</h3>
      <ul className="family-letter-leaflets__list">
        {leaflets.map((l) => (
          <li key={l.key || l.url} className="harbour-body-16">
            <a className="harbour-text-link" href={l.url} target="_blank" rel="noopener noreferrer">
              {l.title}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
